import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { TransactionDetails } from './TransactionDetails';

export class TransactionDetailsResource extends FBaseService {
  public async getByFiIdAndCycleIdAndTransactionType(fiId: string, cycleId: string, akk: string, transactionType: string)
    : Promise<TransactionDetails[]> {
    try {
      const response: AxiosResponse = await this.apiClient.get(
        `/api/rcx/reporting/${fiId}/transaction-details/${akk}/${cycleId}/${transactionType}`,
      );
      const results: TransactionDetails[] = response.data.data.transactions;
      return results;
    } catch (error) {
      if (error.response.status === 404) {
        return [];
      }
      throw error;
    }
  }
}

export default TransactionDetailsResource;
